module.exports = __webpack_public_path__ + "files/c2f4996746ca9df27d88343c2174c250.png";